@if (renderMode === 'modal') {
<aurora-modal
    [open]="true"
    headline="Notification Settings"
    primaryAction="Save"
    (close)="cancel.emit()">
    <ng-container [ngTemplateOutlet]="settingsContent"></ng-container>

    <div slot="footer">
        <aurora-button id="PrimaryButton" variant="primary" [disabled]="!hasChanges"
            (click)="onSave()">Save</aurora-button>
        <aurora-button id="SecondaryButton" variant="secondary" (click)="cancel.emit()">Cancel</aurora-button>
    </div>
</aurora-modal>
} @else {
<div class="settings-inline" aurora-light>
    <ng-container [ngTemplateOutlet]="settingsContent"></ng-container>

    <div class="settings-inline-actions">
        <aurora-button variant="primary" [disabled]="!hasChanges" (click)="onSave()">Save</aurora-button>
    </div>
</div>
}

<ng-template #settingsContent>
    <aurora-loading-indicator *ngIf="!model"></aurora-loading-indicator>

    <ng-container *ngIf="model">
        <div class="form-group enable_popups">
            <aurora-toggle
                id="enableInAppNotificationPopups"
                name="enableInAppNotificationPopups"
                label="Enable in-app notification popups"
                [checked]="model.EnableInAppNotificationPopups"
                (change)="onToggleChange($event, 'EnableInAppNotificationPopups')">
            </aurora-toggle>
        </div>

        <div class="form-group">
            <h2 class="mb-2">Notification Types</h2>

            <aurora-checkbox
                id="journalEntryNotifications"
                name="journalEntryNotifications"
                label="Account Owner - Journal Entries"
                [checked]="model.JournalEntryNotifications"
                (change)="onToggleChange($event, 'JournalEntryNotifications')"></aurora-checkbox>

            <aurora-checkbox
                id="comments"
                name="comments"
                label="Comments"
                [checked]="model.CommentNotifications"
                (change)="onToggleChange($event, 'CommentNotifications')"></aurora-checkbox>

            <aurora-checkbox
                id="delegation"
                name="delegation"
                label="Task Delegation"
                [checked]="model.TaskDelegationNotifications"
                (change)="onToggleChange($event, 'TaskDelegationNotifications')"></aurora-checkbox>

            <aurora-checkbox
                id="programRevisionNotifications"
                name="programRevisionNotifications"
                label="Program Revision"
                [checked]="model.ProgramRevisionNotifications"
                (change)="onToggleChange($event, 'ProgramRevisionNotifications')"></aurora-checkbox>

            <aurora-checkbox
                *sm-tenant-has-facet="TENANT_PERMISSIONS.Flag_Base_Work_Accounts_EmailManagement"
                id="emailNotifications"
                name="emailNotifications"
                label="Account Owner - New Email"
                [checked]="model.EmailNotifications"
                (change)="onToggleChange($event, 'EmailNotifications')"></aurora-checkbox>
        </div>

        <div class="form-group">
            <aurora-label id="expirationDurationOfReadNotificationsInDays">Remove read notifications after</aurora-label>
            <aurora-dropdown
                id="expirationDurationOfReadNotificationsInDays"
                ariaLabel="Remove read notifications after"
                [items]="expirationDropdownItems"
                [value]="model.ExpirationDurationOfReadNotificationsInDays.toString()"
                (value-change)="onExpirationDurationChange($event)">
            </aurora-dropdown>
        </div>
    </ng-container>
</ng-template>
